import { ConfigModel } from './models/configModel';
import { Singleton } from 'typescript-ioc/es5';

@Singleton
export class ConfigService {
    public config: ConfigModel;
}
